import {filterArrayUndefined} from '@coolcolduk/util';
import {Job, mapJobDbToType} from '@cp/model';
import {onSnapshot} from 'firebase/firestore';
import getJobsCollectionRef from './getJobsCollectionRef';

export default function subscribeJobs(onData: (jobs: Job[]) => void, onError?: (err: Error) => void): () => void {
  const col = getJobsCollectionRef();
  return onSnapshot(
    col,
    (snapshot) => {
      const jobs = filterArrayUndefined(snapshot.docs.map((d) => mapJobDbToType(d)));
      onData(jobs);
    },
    (err) => onError?.(err),
  );
}
